export const CRAFT_DEFAULT_STATE = {
  ROOT: {
    type: { resolvedName: "Container" },
    isCanvas: true,
    props: {
      background: "#f9fafb",
      padding: 16,
      margin: 0,
      borderRadius: 0,
      gap: 20,
      minHeight: "100vh",
      width: "100%",
      maxWidth: "1280px",
    },
    displayName: "Main Page Canvas",
    custom: {},
    hidden: false,
    nodes: ["hero-node-1", "features-node-1", "product-node-1", "promo-node-1", "testimonials-node-1", "contact-node-1", "footer-node-1"],
    linkedNodes: {},
  },
  "hero-node-1": {
    type: { resolvedName: "HeroBanner" },
    isCanvas: false,
    props: {
      eyebrow: "✨ CRAFTED FOR EXCELLENCE",
      title: "Elevate Your Lifestyle with Modern Elegance",
      subtitle: "Discover our handpicked collection of premium products made with passion and sustainable quality.",
      primaryButtonText: "Shop Collection",
      secondaryButtonText: "Explore Offers",
      primaryColor: "#4f46e5",
      secondaryColor: "#ffffff",
      textColor: "#ffffff",
      bgGradient: "from-slate-950 via-indigo-950 to-slate-900",
      bgImage: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&auto=format&fit=crop&q=80",
      overlayOpacity: 70,
      minHeight: "480px",
    },
    displayName: "Hero Banner",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "features-node-1": {
    type: { resolvedName: "FeaturesList" },
    isCanvas: false,
    props: {
      feature1Title: "Fast Delivery",
      feature1Desc: "Express shipping nationwide",
      feature2Title: "Secure Payments",
      feature2Desc: "UPI, Cards, NetBanking, COD",
      feature3Title: "24/7 Support",
      feature3Desc: "Instant WhatsApp assistance",
      feature4Title: "Easy Returns",
      feature4Desc: "7-day hassle-free replacement",
      backgroundColor: "#ffffff",
      iconColor: "#4f46e5",
    },
    displayName: "Feature Highlights",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "product-node-1": {
    type: { resolvedName: "ProductShowcase" },
    isCanvas: false,
    props: {
      sectionTitle: "Trending & Best Sellers",
      sectionSubtitle: "Most loved essentials by our satisfied shoppers",
      columns: 4,
      primaryColor: "#4f46e5",
      cardBackground: "#ffffff",
      borderRadius: 16,
      showRating: true,
      showBadge: true,
    },
    displayName: "Product Showcase",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "promo-node-1": {
    type: { resolvedName: "PromoBanner" },
    isCanvas: false,
    props: {
      badge: "EXCLUSIVE PROMOTION",
      title: "Get Flat 20% Off On All Orders",
      subtitle: "Use coupon code SPECIAL20 during checkout. Limited time deal!",
      couponCode: "SPECIAL20",
      buttonText: "Shop Now",
      backgroundColor: "#4338ca",
      textColor: "#ffffff",
    },
    displayName: "Promo Banner",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "testimonials-node-1": {
    type: { resolvedName: "TestimonialsSection" },
    isCanvas: false,
    props: {
      heading: "Customer Reviews",
      subheading: "What our verified buyers love about our brand",
      primaryColor: "#4f46e5",
      backgroundColor: "#ffffff",
    },
    displayName: "Testimonials",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "contact-node-1": {
    type: { resolvedName: "ContactSection" },
    isCanvas: false,
    props: {
      title: "Questions? Connect With Us",
      subtitle: "Our friendly team is always here to help you with your orders and inquiries.",
      phone: "+91 98765 43210",
      email: "support@dukanbuddy.com",
      address: "Main Market, Commercial Plaza, Store #42",
      primaryColor: "#4f46e5",
      whatsappButtonText: "Chat on WhatsApp",
    },
    displayName: "Contact Section",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
  "footer-node-1": {
    type: { resolvedName: "FooterSection" },
    isCanvas: false,
    props: {
      storeName: "Custom Online Store",
      tagline: "Your favorite local destination for quality merchandise and instant delivery.",
      copyright: "© 2026 All Rights Reserved. Built with DukanBuddy.",
      backgroundColor: "#0f172a",
      textColor: "#94a3b8",
      headingColor: "#ffffff",
    },
    displayName: "Footer Section",
    parent: "ROOT",
    nodes: [],
    linkedNodes: {},
  },
};
